'use client';
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import classnames from 'classnames';
import svg4everybody from 'svg4everybody';
import { nanoid } from 'nanoid';
import icons from '../../icons/spritemap/spritemap.svg';
export const Icon = (_a) => {
    var { className, name, focusable = false, id, inverted, title, size = 'sm' } = _a, other = __rest(_a, ["className", "name", "focusable", "id", "inverted", "title", "size"]);
    const [idVar, setId] = React.useState('');
    React.useEffect(() => {
        setId(id || nanoid());
        svg4everybody();
    }, [id]);
    if (!name || name === 'none') {
        return null;
    }
    const componentClassName = classnames('sparky-c-icon', `sparky-c-icon--${name}`, `sparky-c-icon--${size}`, className, {
        'sparky-c-icon--inverted': inverted === true,
    });
    return (_jsxs("svg", Object.assign({ "aria-hidden": !title, "aria-labelledby": title && idVar, className: componentClassName, focusable: focusable, role: title && 'img' }, other, { children: [title && _jsx("title", Object.assign({ id: idVar }, { children: title })), _jsx("use", { href: name && `${icons}#${name}` })] })));
};
//# sourceMappingURL=Icon.js.map